// PWA support
import { registerSW } from 'virtual:pwa-register'
registerSW({ immediate: true })

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap"
import "bootstrap-icons/font/bootstrap-icons.css";
import $ from 'jquery';
import 'lightbox2/dist/css/lightbox.min.css';
import 'lightbox2/dist/js/lightbox.min.js';
import CookieService from './Services/CookieService';
import SEOService from './Services/SEOService';

// Make Bootstrap available globally
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Make services available globally
window.CookieService = CookieService;
window.SEOService = SEOService;

// Configure axios globally
import axios from 'axios';
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Get CSRF token from meta tag
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

// Emit bootstrap loaded event after a short delay to ensure it's ready
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        const event = new CustomEvent('bootstrap:loaded');
        document.dispatchEvent(event);
    }, 100);
});

import '../css/app.css';

import { createApp, h } from 'vue';
//import { createSSRApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import TopNavBar from './Components/TopNavBar.vue';
import VueLazyload from '@jambonn/vue-lazyload'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import ApexCharts from 'vue3-apexcharts'

library.add(fas, far)

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'PriceCompare';

import tooltip from "./Directives/tooltip.js";

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .component('font-awesome-icon', FontAwesomeIcon)
            .component('TopNavBar', TopNavBar)
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(ApexCharts)
            .use(VueLazyload, {
                preLoad: 1.3,
                attempt: 1
            })
            .directive('tooltip', tooltip) // Define the 'tooltip' directive
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
